import { useMediaQuery } from "@mui/material";

export const useDashboardAnalyticsData = () => {
    const smallScreen = useMediaQuery("(min-width : 0px) and (max-width : 768px)");
    const laptopScreen = useMediaQuery("(min-width : 0px) and (max-width : 1400px)");
    const desktopScreen = useMediaQuery("(min-width : 0px)");
    const isScreenBelow800 = useMediaQuery("(min-width : 0px) and (max-width : 800px)");

    const getOmniChannelTotalInteractions = (omichanelOverviewData: any) => {
        return omichanelOverviewData?.reduce((sum: number, item: any) => sum + (item.value || 0), 0);
    }

    const getTotalCampaigns = (analyticsData: any) => {
        return analyticsData?.[0]?.total_campaign_run?.reduce((acc: number, item: any) => acc + item.count, 0);
    }

    const getTotalNewUsers = (analyticsData: any) => {
        return analyticsData?.[0]?.comparison?.reduce((acc: number, item: any) => {
            return acc + item.data.reduce((count: number, item: any) => count + item.new_users, 0);
        }, 0);
    }

    const getTotalReturningUsers = (analyticsData: any) => {
        return analyticsData?.[0]?.comparison?.reduce((acc: number, item: any) => {
            return acc + item.data.reduce((count: number, item: any) => count + item.returning_users, 0);
        }, 0);
    }

    const getNewUsersSeries = (sortedComparison: any) => {
        return sortedComparison?.map((item: any) =>
            item.data.reduce((sum: number, d: any) => sum + d.new_users, 0)
        );
    }

    const getReturningUsersSeries = (sortedComparison: any) => {
        return sortedComparison?.map((item: any) =>
            item.data.reduce((sum: number, d: any) => sum + d.returning_users, 0)
        );
    }

    return {
        smallScreen,
        laptopScreen,
        desktopScreen,
        isScreenBelow800,
        getOmniChannelTotalInteractions,
        getTotalNewUsers,
        getTotalReturningUsers,
        getTotalCampaigns,
        getNewUsersSeries,
        getReturningUsersSeries,
    };
};